import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import TermsIcon from '@material-ui/icons/DescriptionOutlined';
import LoginIcon from '@material-ui/icons/ExitToAppOutlined';
import { createStyles, makeStyles } from '@material-ui/styles';
import utils from 'utils/utils';
import config from 'config';
import { ETitleModal } from '../../component/modal_full_screen';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import UserType from 'constants/user';
import { useHistory, useLocation } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { DescriptionOutlined } from '@material-ui/icons';
import themes from 'styles/themes';
import { ReactComponent as Signup } from '../../assets/svg/Signup.svg';
export const useStyles = makeStyles(() =>
    createStyles({
        // root: {
        //     display: "flex",
        //     boxShadow: "0 2px 5px rgb(0 0 0 / 20%)",
        // },
        span: {
            textDecoration: 'none',
            color: themes.palette.primary.main,
            fontWeight: 600,
            fontSize: 14,
            display: 'block',
            margin: '24px 0',
            padding: '0 0 10px 0',
            borderBottom: '1px solid #D1D1D1',
            fontFamily: 'PoppinsRegular',
        },
        sideBarContainer: {},
    }),
);
interface Props {
    handleDrawerToggle: () => void;
    handleClickOpen: any;
    item?: String;
}
export default function MainListItems({ handleDrawerToggle, handleClickOpen, item }: Props) {
    const classes = useStyles();
    const history = useHistory();
    const location: any = useLocation();
    const userDetail = useSelector((state: RootState) => state.userDetail.me);

    const renderUnauthenticatedMenu = () => {
        return (
            <>
                <span
                    onClick={() => {
                        history.push(PATH.SIGNUP_CUSTOMER);
                    }}
                    className={classes.span}
                >
                    <span>
                        <Signup style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>{' '}
                    Sign Up
                </span>
                <span
                    onClick={() => {
                        history.push(PATH.LOGIN);
                    }}
                    className={classes.span}
                >
                    <span>
                        <LoginIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>
                    {''}
                    Login
                </span>
            </>
        );
    };

    return (
        <div className={classes.sideBarContainer}>
            <div>
                {(location.pathname.includes(PATH.DISCOVER_YOUR_STYLE) ||
                    location.pathname.includes(PATH.ITEM_DETAIL) ||
                    location.pathname.includes(PATH.STYLE_DETAIL) ||
                    location.pathname.includes(PATH.STYLE_ASSISTANT)) &&
                    !userDetail &&
                    renderUnauthenticatedMenu()}
                {false && (
                    <span onClick={() => handleClickOpen('FAQ', ETitleModal.FAQ)} className={classes.span}>
                        <span>
                            <ContactSupportOutlinedIcon
                                style={{ color: themes.palette.primary.main, marginRight: 10 }}
                            />
                        </span>{' '}
                        FAQ
                    </span>
                )}
                {false && (
                    <span
                        onClick={() => handleClickOpen('Invite friends', ETitleModal.INVITE)}
                        className={classes.span}
                    >
                        <span>
                            <PersonAddOutlinedIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                        </span>{' '}
                        Invite friends
                    </span>
                )}
                {false && (
                    <span onClick={() => handleClickOpen('Settings', ETitleModal.SETTING)} className={classes.span}>
                        <span>
                            <SettingsOutlinedIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                        </span>{' '}
                        Settings
                    </span>
                )}
                {userDetail && userDetail.userType === UserType.Stylist && userDetail?.approved && (
                    <span onClick={() => history.push(PATH.STYLIST_TUTORIAL)} className={classes.span}>
                        <span>
                            <DescriptionOutlined style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                        </span>
                        Stylist Manual
                    </span>
                )}
                <span
                    //onClick={() => handleClickOpen("Settings")}
                    className={classes.span}
                >
                    <span>
                        <TermsIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>
                    {utils.getAnchorNewTab(config.termsOfService.url, config.termsOfService.text, {
                        color: themes.palette.primary.main,
                        textDecoration: 'none',
                    })}
                </span>
                <span
                    //onClick={() => handleClickOpen("Privacy Policy")}
                    className={classes.span}
                >
                    <span>
                        <VerifiedUserOutlinedIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>
                    {utils.getAnchorNewTab(config.privacyPolicy.url, config.privacyPolicy.text, {
                        color: themes.palette.primary.main,
                        textDecoration: 'none',
                    })}
                </span>

                <span onClick={() => handleClickOpen('Contact Us', ETitleModal.CONTACT_US)} className={classes.span}>
                    <span>
                        <CallOutlinedIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>
                    Contact Us
                </span>
                <span onClick={() => handleClickOpen('App Version', ETitleModal.APP_VERSION)} className={classes.span}>
                    <span>
                        <InfoOutlinedIcon style={{ color: themes.palette.primary.main, marginRight: 10 }} />
                    </span>
                    App Version
                </span>
            </div>
        </div>
    );
}
